import React, { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { creativeManagerV2AccessControl } from '../access-control/creativeManagerAccess.configuration'
import {
  contentPagesDeletedSiteScopedAccessControl,
  contentPagesMultiWarehouseAccessControl,
  pageBuilderViewAccessControl,
  storefrontHomepageDashboardV2,
} from '../access-control/storefrontAccess.configuration'

const StorefrontContentPagesDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontContentPagesDashboardPage" */
      '../pages/content-pages-dashboard/StorefrontContentPagesDashboardPage'
    )
)

const StorefrontDeletedContentPagesDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontDeletedContentPagesDashboardPage" */
      '../pages/content-pages-dashboard/StorefrontDeletedContentPagesDashboardPage'
    )
)

const StorefrontContentPagesBuilder = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontContentPagesBuilder" */
      '../pages/content-pages-builder/StorefrontContentPagesBuilderPage'
    )
)

// @hygen:inject page-import
const StorefrontCreativeManagerPageV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontCreativeManagerPageV2" */
      '../pages/creative-manager/CreativeManagerPageV2'
    )
)

const StorefrontHomepageDashboardV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontHomepageDashboardV2" */
      '../pages/homepage-dashboard/StorefrontHomepageDashboardPageV2'
    )
)

const StorefrontPartnerHomepageBuilderPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontHomepageBuilderPage" */
      '../pages/homepage-builder/StorefrontPartnerHomepageBuilderPage'
    )
)

export const storefrontPartnerScopedRouter = (
  <DomainRoute route="storefront-partner-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="storefront-creative-manager-v2"
        tool="creatives-dashboard-tool"
        component={StorefrontCreativeManagerPageV2 as ComponentType<any>}
        accessControl={creativeManagerV2AccessControl}
      />
      <DomainRoute
        exact
        route="storefront-homepage-dashboard-v2"
        tool="custom-homepage-dashboard-tool"
        component={StorefrontHomepageDashboardV2 as ComponentType<any>}
        accessControl={storefrontHomepageDashboardV2}
      />
      <DomainRoute
        exact
        route="storefront-homepage-edit-v2"
        tool="custom-homepage-dashboard-tool"
        component={StorefrontPartnerHomepageBuilderPage as ComponentType<any>}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-dashboard-partner-scoped"
        tool="content-pages-dashboard-tool"
        component={StorefrontContentPagesDashboardPage as ComponentType<any>}
        accessControl={contentPagesMultiWarehouseAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-deleted-partner-scoped"
        tool="content-pages-dashboard-tool"
        component={StorefrontDeletedContentPagesDashboardPage as ComponentType<any>}
        accessControl={contentPagesDeletedSiteScopedAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-create-partner-scoped"
        tool="content-pages-dashboard-tool"
        component={StorefrontContentPagesBuilder as ComponentType<any>}
        accessControl={contentPagesMultiWarehouseAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-edit-partner-scoped"
        tool="content-pages-dashboard-tool"
        component={StorefrontContentPagesBuilder as ComponentType<any>}
        accessControl={contentPagesMultiWarehouseAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-edit-version-partner-scoped"
        tool="content-pages-dashboard-tool"
        component={StorefrontContentPagesBuilder as ComponentType<any>}
        accessControl={contentPagesMultiWarehouseAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
